
/** SAMPLE  */
export const _KEY = {};

/**
 * 참고
 * 1. object 내부에 주석한 것은, 
 *    originalData에 값이 없거나, 변형해야 하는 경우. (dataLayer.push 전에 값 추가 필요.)
 */

/** 회원 가입 완료 */
export const SIGNUP_COMPLETE_KEY = {
	'event': 'signup_complete',
  // 'recommendation_check': 'recommendation_check', // '{추천인 코드 입력 여부}',
  'recommender': 'recommendation_code', // '{입력 사원번호/추천인코드}',
  // 'userNo': 'user_id', // userNo
  'companyName': 'company_name', // '{상호명}',
  'bizNo': 'company_number', // '{사업자등록번호}',
  'companyTypeCd': 'company_type', // '{사업자 구분}',
  'smsAgreeYn': 'sms_receive_agreement', // '{문자 알림 마케팅 수신 동의 여부}',
  'mailingAgreeYn': 'email_receive_agreement', // '{이메일 알림 마케팅 수신 동의 여부}',
  // 'signup_date': 'signup_date', // '{회원가입 연-월-일}',
  // 'register_channel': 'register_channel', // '{가입채널 구분}' - 'Mobile' 고정값
};

/** 로그인. 사용X */
export const LOGIN_KEY = {
  'event': 'login',
  'user_id': 'user_id', // '{UUID}'
};

/** [비즈 SHOP > 상품 상세 페이지] > 1. 상품 상세 페이지 진입 */
// Q. category_id, category_name에 1depth 카테고리만 작성하면 되는건가요?
export const GOODS_DETAIL_VIEW_KEY = {
	'event': 'goods_detail_view',
  'goodsNo': 'goods_id', // '{상품의 ID}',
  'goodsName': 'goods_name', // '{상품명}',
  'realPrice': 'regular_price', // '{상품의 정가}',
  'discountPrice': 'price', // '{상품의 판매가}',
  'limitDay': 'expiry_date', // '{상품의 유효기간(day)}',
  // 'categorySeq1': 'category_id', // '{상품의 카테고리 ID}', 
  // 'categoryName1': 'category_name', // '{상품의 카테고리명}',
  'brandCode': 'brand_id', // '{상품의 브랜드 ID}',
  'brandName': 'brand_name', // '{상품의 브랜드명}'
};

/** [비즈 SHOP > 상품 상세 페이지] > 2-1. 바로구매 버튼 클릭 */
export const GOODS_DETAIL_GOORDER_KEY = {
	'event': 'goods_detail_goorder',
};

/** [비즈 SHOP > 상품 상세 페이지] > 2-2. 장바구니 버튼 클릭 */
export const GOODS_DETAIL_ADDTOCART_KEY = {
	'event': 'goods_detail_addtocart',
};

/** [비즈 SHOP > 상품 상세 페이지] > 2-3. 견적담기 버튼 클릭 */
export const GOODS_DETAIL_ESTIMATE_KEY = {
	'event': 'goods_detail_estimate',
};

/** [비즈 SHOP > 상품 상세 페이지] > 2-4. URL 복사 아이콘 클릭 */
// export const GOODS_DETAIL_URL_SHARE_KEY = {
// 	'event': '', // 'goods_detail_url_share'
// };

/** 
 * [비즈 SHOP > 상품 상세 페이지] > 2-5. 모바일 화면의 공유 버튼
 *  > 페이스북 공유 버튼 클릭 시
 */
export const GOODS_DETAIL_FACEBOOK_SHARE_KEY = {
	'event': 'goods_detail_facebook_share',
};

/** 
 * [비즈 SHOP > 상품 상세 페이지] > 2-5. 모바일 화면의 공유 버튼
 *  > 카카오톡 공유 버튼 클릭 시
 */
export const GOODS_DETAIL_KAKAOTALK_SHARE_KEY = {
	'event': 'goods_detail_kakaotalk_share',
};

/** 
 * [비즈 SHOP > 상품 상세 페이지] > 2-5. 모바일 화면의 공유 버튼
 *  > URL 공유 버튼 클릭 시
 */
export const GOODS_DETAIL_URL_SHARE_KEY = {
	'event': 'goods_detail_url_share',
};

/** 
//  * [비즈 SHOP > 상품 상세 페이지] > 3. 동일 카테고리 내 유사 가격 인기상품 섹션 내 클릭
//  * 3-1. 바로주문 숏컷 클릭
//  */
// export const GOODS_DETAIL_RELATED_SHORTCUT_GOORDER_KEY = {
// 	'event': 'goods_detail_related_shortcut_goorder',
//   'related_goods_id': 'related_goods_id', // '{클릭한 상품의 ID}',
//   'related_goods_name': 'related_goods_name', // '{클릭한 상품명}',
//   'related_price': 'related_price', // '{클릭한 상품의 판매가}',
//   'related_expiry_date': 'related_expiry_date', // '{클릭한 상품의 유효기간(day)}',
//   'related_brand_id': 'related_brand_id', // '{클릭한 상품의 브랜드 ID}',
//   'related_brand_name': 'related_brand_name', // '{클릭한 상품의 브랜드명}'
// };

// /** 
//  * [비즈 SHOP > 상품 상세 페이지] > 3. 동일 카테고리 내 유사 가격 인기상품 섹션 내 클릭
//  * 3-2. 장바구니 담기 숏컷 클릭
//  */
// export const GOODS_DETAIL_RELATED_SHORTCUT_ADDTOCART_KEY = {
// 	'event': 'goods_detail_related_shortcut_addtocart',
//   'related_goods_id': 'related_goods_id', // '{클릭한 상품의 ID}',
//   'related_goods_name': 'related_goods_name', // '{클릭한 상품명}',
//   'related_price': 'related_price', // '{클릭한 상품의 판매가}',
//   'related_expiry_date': 'related_expiry_date', // '{클릭한 상품의 유효기간(day)}',
//   'related_brand_id': 'related_brand_id', // '{클릭한 상품의 브랜드 ID}',
//   'related_brand_name': 'related_brand_name', // '{클릭한 상품의 브랜드명}'
// };

// /** 
//  * [비즈 SHOP > 상품 상세 페이지] > 3. 동일 카테고리 내 유사 가격 인기상품 섹션 내 클릭
//  * 3-3. 견적 담기 숏컷 클릭
//  */
// export const GOODS_DETAIL_RELATED_SHORTCUT_ESTIMATE_KEY = {
// 	'event': 'goods_detail_related_shortcut_estimate',
//   'related_goods_id': 'related_goods_id', // '{클릭한 상품의 ID}',
//   'related_goods_name': 'related_goods_name', // '{클릭한 상품명}',
//   'related_price': 'related_price', // '{클릭한 상품의 판매가}',
//   'related_expiry_date': 'related_expiry_date', // '{클릭한 상품의 유효기간(day)}',
//   'related_brand_id': 'related_brand_id', // '{클릭한 상품의 브랜드 ID}',
//   'related_brand_name': 'related_brand_name', // '{클릭한 상품의 브랜드명}'
// };

/** 
 * [비즈 SHOP > 상품 상세 페이지] > 3. 동일 카테고리 내 유사 가격 인기상품 섹션 내 클릭
 * 3-4. 상품 클릭
 * 유사가격 인기 상품 상품 클릭 시 아래 스크립트를 실행합니다.
 */
export const GOODS_DETAIL_RELATED_CLICK_KEY = {
	'event': 'goods_detail_related_click',
  'goodsNo': 'related_goods_id', // '{클릭한 상품의 ID}',
  'goodsName': 'related_goods_name', // '{클릭한 상품명}',
  'discountPrice': 'related_price', // '{클릭한 상품의 판매가}',
  'limitDay': 'related_expiry_date', // '{클릭한 상품의 유효기간(day)}',
  'brandCode': 'related_brand_id', // '{클릭한 상품의 브랜드 ID}',
  'brandName': 'related_brand_name', // '{클릭한 상품의 브랜드명}'
};

/** [비즈 SHOP > 비즈 SHOP 페이지] > 1. 비즈 SHOP 페이지 접속 / 갱신 */
export const BIZSHOP_VIEW_KEY = {
	'event': 'bizshop_view',
  'categoryName': 'select_category', // '{선택 카테고리}',
  'brandName': 'select_brand', // '{선택 브랜드}',
  'exhGenderCd': 'select_gender', // '{선택 성별}',
  'exhAgeCd': 'select_age', // '{선택 연령}',
  'priceRange': 'select_price', // '{선택 가격}',
  'lineUp': 'sort', //    '{선택 정렬 방식}',
  'view_number': 'view_number', // '{선택 보기 개수}'
};

/** [비즈 SHOP > 비즈 SHOP 페이지] > 2. 비즈 SHOP 결과 내 재검색 */
export const BIZSHOP_SEARCH_IN_RESULT_KEY = {
	'event': 'bizshop_search_in_result',
  'categoryName': 'select_category', // '{선택 카테고리}',
  'brandName': 'select_brand', // '{선택 브랜드}',
  'exhGenderCd': 'select_gender', // '{선택 성별}',
  'exhAgeCd': 'select_age', // '{선택 연령}',
  'priceRange': 'select_price', // '{선택 가격}',
  'sort': 'sort', // '{선택 정렬 방식}',
  'view_number': 'view_number', // '{선택 보기 개수}',
	'keyword': 'keyword', // '{검색 키워드}'
};

/** [비즈 SHOP > 비즈 SHOP 페이지] > 3-1. 바로주문 숏컷 클릭 */
export const BIZSHOP_SHORTCUT_GOORDER_KEY = {
	'event': 'bizshop_shortcut_goorder',
  'goodsNo': 'goods_id', // '{클릭한 상품의 ID}',
  'goodsName': 'goods_name', // '{클릭한 상품명}',
  'discountPrice': 'price', // '{클릭한 상품의 판매가}',
  'limitDay': 'expiry_date', // '{클릭한 상품의 유효기간(day)}',
  'brandCode': 'brand_id', // '{상품의 브랜드 ID}',
  'brandName': 'brand_name', // '{상품의 브랜드명}'
};

/** [비즈 SHOP > 비즈 SHOP 페이지] > 3-2. 장바구니 담기 숏컷 클릭 */
export const BIZSHOP_SHORTCUT_ADDTOCART_KEY = {
	'event': 'bizshop_shortcut_addtocart',
  'goodsNo': 'goods_id', // '{클릭한 상품의 ID}',
  'goodsName': 'goods_name', // '{클릭한 상품명}',
  'discountPrice': 'price', // '{클릭한 상품의 판매가}',
  'limitDay': 'expiry_date', // '{클릭한 상품의 유효기간(day)}',
  'brandCode': 'brand_id', // '{상품의 브랜드 ID}',
  'brandName': 'brand_name', // '{상품의 브랜드명}'
};

/** [비즈 SHOP > 비즈 SHOP 페이지] > 3-3. 견적 담기 숏컷 클릭 */
export const BIZSHOP_SHORTCUT_ESTIMATE_KEY = {
	'event': 'bizshop_shortcut_estimate',
  'goodsNo': 'goods_id', // '{클릭한 상품의 ID}',
  'goodsName': 'goods_name', // '{클릭한 상품명}',
  'discountPrice': 'price', // '{클릭한 상품의 판매가}',
  'limitDay': 'expiry_date', // '{클릭한 상품의 유효기간(day)}',
  'brandCode': 'brand_id', // '{상품의 브랜드 ID}',
  'brandName': 'brand_name', // '{상품의 브랜드명}'
};

/** [주문발송 - 주문정보 페이지] > 1. 주문정보 페이지 진입  */
export const ORDER_INFO_VIEW_KEY = {
	'event': 'order_info_view',
  'goods_id': 'goods_id', // '[상품의 ID 배열]',
  'goods_name': 'goods_name', // '[상품명 배열]',
  'regular_price': 'regular_price', // '[상품의 정가 배열]',
  'price': 'price', // '[상품의 판매가 배열]',
  'expiry_date': 'expiry_date', // '[상품의 유효기간(day) 배열]',
  'category_id': 'category_id', // '[상품의 카테고리 ID 배열]',
  'category_name': 'category_name', // '[상품의 카테고리명 배열]',
  'brand_id': 'brand_id', // '[상품의 브랜드 ID 배열]',
  'brand_name': 'brand_name', // '[상품의 브랜드명 배열]'
};

/** 
 * [주문발송 - 주문정보 페이지] > 2. 수신 정보 - 수신할 메시지
 * 2-1. 메시지 미리보기 버튼 클릭
 */
export const ORDER_RECEIVEINFO_MESSAGE_PREVIEW_CLICK_KEY = {
	'event': 'order_receiveinfo_message_preview_click',
};

/** 
 * [주문발송 - 주문정보 페이지] > 2. 수신 정보 - 수신할 메시지
 * 2-2. 메시지 저장 완료
 */
export const ORDER_RECEIVEINFO_MESSAGE_SAVE_KEY = {
	'event': 'order_receiveinfo_message_save',
  'message_title': 'message_title', // '{저장한 메시지 제목 텍스트}'
};

/** 
 * [주문발송 - 주문정보 페이지] > 2. 수신 정보 - 수신할 메시지
 * 2-3. 불러오기 버튼 클릭
 */
export const ORDER_RECEIVEINFO_MESSAGE_LOAD_CLICK_KEY = {
	'event': 'order_receiveinfo_message_load_click',
};

/** 
 * [주문발송 - 주문정보 페이지] > 2. 수신 정보 - 수신할 메시지
 * 2-4. 메시지 불러오기 완료
 */
export const ORDER_RECEIVEINFO_MESSAGE_LOAD_COMPLETE_KEY = {
	'event': 'order_receiveinfo_message_load_complete',
  'message_title': 'message_title', // '{불러온 메시지 제목 텍스트}'
};

/** 
 * [주문발송 - 주문정보 페이지] > 2. 수신 정보 - 수신할 메시지
 * 2-5. 모바일 상품권 꾸미기 클릭
 */
export const ORDER_RECEIVEINFO_MESSAGE_BANNERCARD_MODIFY_CLICK_KEY = {
	'event': 'order_receiveinfo_message_bannercard_modify_click',
};

/** 
 * [주문발송 - 주문정보 페이지] > 2. 수신 정보 - 수신할 메시지
 * 2-6. 모바일 상품권 배너, 카드 변경 완료
 */
export const ORDER_RECEIVEINFO_MESSAGE_BANNERCARD_MODIFY_COMPLETE_KEY = {
	'event': 'order_receiveinfo_message_bannercard_modify_complete',
};

/** 
 * [주문발송 - 주문정보 페이지] > 3. 수신 정보 - 수신자 정보 입력
 * 3-1. 양식 다운로드 버튼 클릭
 */
export const ORDER_RECEIVEINFO_EXCEL_FORM_DOWNLOAD_KEY = {
	'event': 'order_receiveinfo_excel_form_download',
};

/** 
 * [주문발송 - 주문정보 페이지] > 3. 수신 정보 - 수신자 정보 입력
 * 3-2. Excel 업로드 완료
 */
export const ORDER_RECEIVEINFO_EXCEL_UPLOAD_KEY = {
	'event': 'order_receiveinfo_excel_upload',
};

/** [주문발송 - 주문정보 페이지] > 4. 임시 저장  */
export const ORDER_TEMP_SAVE_KEY = {
	'event': 'order_temp_save',
  'order_name': 'order_name', // '{주문명}',
  'outgoing_number': 'outgoing_number', // '{발신번호}',
  'method': 'method', // '{발신수단}',
  'type': 'type', // '{발신유형}',
  'final_payment_amount': 'final_payment_amount', // '{최종 결제 금액}',
  'goods_id': 'goods_id', // '[상품의 ID 배열]',
  'goods_name': 'goods_name', // '[상품명 배열]',
  'regular_price': 'regular_price', // '[상품의 정가 배열]',
  'price': 'price', // '[상품의 판매가 배열]',
  'expiry_date': 'expiry_date', // '[상품의 유효기간(day) 배열]',
  'category_id': 'category_id', // '[상품의 카테고리 ID 배열]',
  'category_name': 'category_name', // '[상품의 카테고리명 배열]',
  'brand_id': 'brand_id', // '[상품의 브랜드 ID 배열]',
  'brand_name': 'brand_name', // '[상품의 브랜드명 배열]'
};


/** [주문발송 - 결제정보 페이지] > 1. 결제정보 페이지 진입  */
export const CHECKOUT_KEY = {
  'event': 'checkout',
  'order_name': 'order_name', // '{주문명}',
  'outgoing_number': 'outgoing_number', // '{발신번호}',
  'method': 'method', // '{발신수단}',
  'type': 'type', // '{발신유형}',
	'reciever': 'reciever', // '{수신자 총 수}',
  'goods_id': 'goods_id', // [상품의 ID 배열],
  'goods_name': 'goods_name', // [상품명 배열],
  'regular_price': 'regular_price', // [상품의 정가 배열],
  'price': 'price', // [상품의 판매가 배열],
  'expiry_date': 'expiry_date', // [상품의 유효기간(day) 배열],
  'category_id': 'category_id', // [상품의 카테고리 ID 배열],
  'category_name': 'category_name', // [상품의 카테고리명 배열],
  'brand_id': 'brand_id', // [상품의 브랜드 ID 배열],
  'brand_name': 'brand_name', // [상품의 브랜드명 배열],
  'quantity': 'quantity', // [상품별 수신자 수 배열]
};

/** [주문발송 - 결제정보 페이지] > 2. 자세히보기 클릭  */
export const CHECKOUT_REVIEW_CLICK_KEY = {
  'event': 'checkout_review_click'
};

/** [주문발송 - 결제정보 페이지] > 3-1. 메시지 미리보기 클릭  */
export const CHECKOUT_MESSAGE_PREVIEW_CLICK_KEY = {
  'event': 'checkout_message_preview_click'
};

/** [주문발송 - 결제정보 페이지] > 3-2. 대체 메시지 미리보기 클릭  */
export const CHECKOUT_ALT_MESSAGE_PREVIEW_CLICK_KEY = {
  'event': 'checkout_alt_message_preview_click'
};

/** [주문발송 - 결제정보 페이지] > 3-3. 알림톡 미리보기 클릭  */
export const CHECKOUT_ALIMTALK_PREVIEW_CLICK_KEY = {
  'event': 'checkout_alimtalk_preview_click'
};

/** [주문발송 - 주문완료] > 1. 주문 완료  */
export const PURCHASE_KEY = {
  'event': 'purchase',
	'index': 'index',  // '주문발송',
  'transaction_id': 'transaction_id',  // '{주문 번호}',
  'payment_method': 'payment_method',  // '{결제 수단 구분}',
  'total_price': 'total_price',  // '{상품 총 가격}',
  'discount': 'discount',  // '{할인 금액}',
  'bizmoney_amount': 'bizmoney_amount',  // '{비즈머니 사용 금액}',
  'final_payment_amount': 'final_payment_amount',  // '{최종 결제 금액}',
  'revenue': 'revenue',  // '{매출 금액}',
  'order_name': 'order_name',  // '{주문명}',
  'outgoing_number': 'outgoing_number',  // '{발신번호}',
  'method': 'method',  // '{발신수단}',
  'type': 'type',  // '{발신유형}',
  'reciever': 'reciever',  // '{수신자 총 수}',
  'goods_id': 'goods_id',  // [상품의 ID 배열],
  'goods_name': 'goods_name',  // [상품명 배열],
  'regular_price': 'regular_price',  // [상품의 정가 배열],
  'price': 'price',  // [상품의 판매가 배열],
  'expiry_date': 'expiry_date',  // [상품의 유효기간(day) 배열],
  'category_id': 'category_id',  // [상품의 카테고리 ID 배열],
  'category_name': 'category_name',  // [상품의 카테고리명 배열],
  'brand_id': 'brand_id',  // [상품의 브랜드 ID 배열],
  'brand_name': 'brand_name',  // [상품의 브랜드명 배열],
  'quantity': 'quantity',  // [상품별 수신자 수량 배열],
	'check_destroy_agreement': 'check_destroy_agreement',  // '{수신자 정보 자동 파기 여부}'
};

/** [주문발송 - 주문완료] > 3. 주문내역조회 버튼 클릭  */
export const PURCHASE_ORDER_HISTORY_CLICK_KEY = {
  'event': 'purchase_order_history_click'
};

/** 
 * [주문발송 - 주문완료] > 4. 거래명세서
 * 4-1. 거래명세서 팝업 노출 및 거래명세서 페이지 진입(모바일 웹)
 */
export const PURCHASE_TRADE_STATEMENT_VIEW_KEY = {
  'event': 'purchase_trade_statement_view',
  'company_name': 'company_name',  // '{기업명}',
  'transaction_id': 'transaction_id',  // '{주문 번호}',
  'purchase_date': 'purchase_date',  // '{거래일자}',
  'total_price': 'total_price',  // '{합계금액}',
  'goods_id': 'goods_id',  // [상품의 ID 배열],
  'goods_name': 'goods_name',  // [상품명 배열],
  'price': 'price',  // [상품의 단가 배열],
  'expiry_date': 'expiry_date',  // [상품의 유효기간(day) 배열],
  'category_id': 'category_id',  // [상품의 카테고리 ID 배열],
  'category_name': 'category_name',  // [상품의 카테고리명 배열],
  'brand_id': 'brand_id',  // [상품의 브랜드 ID 배열],
  'brand_name': 'brand_name',  // [상품의 브랜드명 배열],
  'quantity': 'quantity',  // [상품별 수량 배열]
};

/** 
 * [주문발송 - 주문완료] > 4. 거래명세서
 * 4-1. 거래명세서 팝업 노출 및 거래명세서 페이지 진입(모바일 웹)
 */
export const PURCHASE_TRADE_STATEMENT_PRINT_KEY = {
  'event': 'purchase_trade_statement_print'
};

/** 
 * [주문발송 - 주문완료] > 4. 거래명세서
 * 4-1. 거래명세서 팝업 노출 및 거래명세서 페이지 진입(모바일 웹)
 */
export const PURCHASE_TRADE_STATEMENT_EXCEL_DOWNLOAD_KEY = {
  'event': 'purchase_trade_statement_excel_download'
};

/** 
 * [주문발송 - 주문완료] > 4. 거래명세서
 * 4-1. 거래명세서 팝업 노출 및 거래명세서 페이지 진입(모바일 웹)
 */
export const PURCHASE_TRADE_STATEMENT_PDF_DOWNLOAD_KEY = {
  'event': 'purchase_trade_statement_pdf_download'
};

/** 
 * [주문발송 - 주문완료] > 4. 거래명세서
 * 4-1. 거래명세서 팝업 노출 및 거래명세서 페이지 진입(모바일 웹)
 */
export const PURCHASE_TRADE_STATEMENT_EMAIL_SEND_KEY = {
  'event': 'purchase_trade_statement_email_send'
};

/** SAMPLE  */
// export const _KEY = {};
